import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { TipoPedido } from '@/models/tipo-pedido';

export class TipoPedidoAPI extends BaseAPI<TipoPedido> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_dash/v1/type_solicitations`;
  }

  public list(params: any): AxiosObservable<TipoPedido[]> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) })
  }

  public create(body: any): AxiosObservable<TipoPedido> {
    return this.axios.post(`${this.apiUrl}`, body);
  }

  public show(id: number): AxiosObservable<TipoPedido> {
    return this.axios.get(`${this.apiUrl}/${id}`)
  }

  public update(id: number, body: any): AxiosObservable<TipoPedido> {
    return this.axios.patch(`${this.apiUrl}/${id}`, body)
  }

  public delete(id: number): AxiosObservable<any> {
    return this.axios.delete(`${this.apiUrl}/${id}`)
  }

  public addDocumentType(solicitationTypeId: number, body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/${solicitationTypeId}/type_documents`, body);
  }

  public listDocumentTypes(solicitationTypeId: number, params: any): AxiosObservable<any> {
    return this.axios
      .get(`${this.apiUrl}/${solicitationTypeId}/type_documents`, { params });
  }

  public removeDocumentType(solicitationTypeId: number, documentTypeId: number): AxiosObservable<any> {
    return this.axios
      .delete(`${this.apiUrl}/${solicitationTypeId}/type_documents/${documentTypeId}`);
  }
}
